import { render, staticRenderFns } from "./Giftbag.vue?vue&type=template&id=57c8654b&scoped=true&"
import script from "./Giftbag.vue?vue&type=script&lang=js&"
export * from "./Giftbag.vue?vue&type=script&lang=js&"
import style0 from "./Giftbag.vue?vue&type=style&index=0&id=57c8654b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c8654b",
  null
  
)

export default component.exports